import { IDataStorage } from '../internal/data-storage';
import { InternalTable } from '../internal/internal-table';
import { InternalIndex } from '@stockcare-storage/internal/internal-index';
import { QueueStatus } from '@stockcare-models/QueueStatus';
import { QueueType } from '@stockcare-models/QueueType';

export class QueueItem implements IDataStorage {
  index: InternalIndex = new InternalIndex('Id', 'Id', true, false);
  tableDefinition: InternalTable = new InternalTable('Queue', 'Id', true, [this.index]);

  Id: number;
  Type: QueueType;
  Value: string;
  Status: QueueStatus;
  DateCreated: Date;
  DateModified: Date;
  RetryCount: number;
  ServerResponse: string;
  CorrelationId: string;
  UserId: string;
  IsOffline: boolean;

  static getTableDefinition(): InternalTable {
    return new QueueItem().tableDefinition;
  }
}
